import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[appComponentResolver]',
})
export class AppComponentResolverDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
